<template>
  <div id="uddanelsebevis" class="animated fadeIn">
    <b-container fluid class="pt-3 pr-3 pb-0 pl-3">
      <b-row>
        <b-col cols="12" class="">
          <!-- Cancellations -->
          <!-- <b-card class="border-0">
            <div class="card-text pb-0">
              <div class="d-flex flex-row justify-content-start">
                <div class="h4 font-weight-bold text-dark">Integrationer </div>
              </div>
            </div>
          </b-card> -->
        </b-col>
      </b-row>
    </b-container>
    <b-form>
      <b-container fluid class="pt-0 pr-3 pb-0 pl-3">
        <b-row>
          <b-col>
            <!-- notifications in general -->
            <b-card class="border-0 p-1">

              <div class="lg-flex flex-row align-items-center justify-content-between lg-col-6 col-12 mb3">
                <!-- <div class="mb2">
                  <b-img class="mr2" src="../static/img/ordrestyring-logo.png" alt="" width="100"/>
                </div> -->
                <div>
                  <span class="h1">Uddannelsesbevis</span>
                  <p>Her kan du uploade firmaets uddannelsesbeviser, for dig og dine ansatte.</p>
                </div>
              </div>

              <div class="card-text pb-0">
                <div>
                  <div class="">
                    <b-col lg="6" md="12" sm="12">
                      <table class="el-table__body col-12 p0 mb4">
                        <thead class="has-gutter">
                          <tr>
                            <th colspan="1" rowspan="1" class="el-table_1_column_1 is-leaf pr2">Navn</th>
                            <th colspan="1" rowspan="1" class="el-table_1_column_1 is-leaf">Uddannelse</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr class="el-table__row" v-for="(education, index) in educationData" :key="index">
                            <td class="el-table_1_column_1 pr2">
                              <span>{{education.CoverImg}}</span>
                            </td>
                            <td class="el-table_1_column_1">
                              <span>{{education.BadgeMonth}}</span><a class="pointer absolute right-0 no-hover" title="Slet"  v-confirm="{ok: confirmDelete(education.Id), message: 'Vil du fjerne disse data?', okText: 'Ja', cancelText: 'Nej'}"><span class="red mr1">Slet</span><i class="el-icon-error h5 red"></i></a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <b-form class="py-2">
                        <div class="col-12 p0">
                          <b-form-group id="name" label=""  label-for="navn" class="lg-col-12 md-col-12 p0 mb3">
                            <b-form-input v-model="name" v-on:keyup="disableerror()" placeholder="Indtast navn" autocomplete="off"></b-form-input>
                            <span class="red alert" v-if="error">{{ errormessagename }}</span>
                          </b-form-group>
                          <b-form-group id="fag" label="" label-for="fag" class="lg-col-12 md-col-12 p0 mb3">
                            <b-form-select v-model="fag" @change="disableerror()" :options="fagOptionData" class="col-12" ></b-form-select>
                            <span class="red alert" v-if="error">{{ errormessagefag }}</span>
                          </b-form-group>
                          <b-form-group id="file" label="" label-for="fag" class="lg-col-12 md-col-12 p0 mb3">
                            <file-upload-input token="" module="" @UpdateTilbud="handleFileUpload" class="education-upload"></file-upload-input>
                          </b-form-group>
                          <b-form-group id="gemme" label="" label-for="gemme" class="lg-col-12 md-col-12 p0 m0 white">
                            <button type="button" class="col-12 flex justify-center items-center btn action-button gibson h5 p2 semi-bold m0" @click="addEducation()" :disabled="sendDisabled"><span>Gem</span></button>
                          </b-form-group>
                        </div>
                      </b-form>
                    </b-col>
                  </div>
                </div>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </b-container>
    </b-form>
    <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
  </div>
</template>
<script>
import Simplert from 'vue2-simplert'
import fileUploadInput from '../../components/file-upload-input'
export default {
  name: '',
  components: {
    Simplert,
    fileUploadInput
  },
  created () {
    this.salesPerson = localStorage.getItem('id_token_portal')
    this.haaId = localStorage.getItem('haaid')
    this.displayEducation()
    this.getFags()
    setTimeout(function () {
      var fileUploadText = document.querySelector('.input-group > button > span:nth-child(2)')
      fileUploadText.innerText = 'Vedhæft uddannelsesbevis'
    }, 500)
    this.errorFeedback()
  },
  data () {
    return {
      salesPerson: '',
      haaId: '',
      educationData: [],
      name: '',
      fag: null,
      fagOptionData: [],
      files: '',
      sendDisabled: false,
      message: [],
      errormessagename: '',
      errormessagefag: '',
      uploaloadstatus: true,
      error: false
    }
  },
  methods: {
    displayEducation () {
      var data = {
        operation: 'listeducation',
        salesPerson: this.salesPerson,
        levid: this.haaId
      }
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.educationData = res
          },
          response => {
            alert('Error in displayEducation()')
          }
        )
    },
    getFags () {
      var data = {
        operation: 'anbefalingercat',
        salesPerson: this.salesPerson,
        levid: this.haaId
      }
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.fagOptionData.push({
              text: 'Vælg uddannelse',
              value: null,
              disabled: true
            },
            {
              text: 'Andet',
              value: 'Andet'
            })
            for (var id in res) {
              var cat = res[id]
              this.fagOptionData.push({
                text: cat.Title,
                value: cat.Title
              })
            }
          },
          response => {
            alert('Error in getFags()')
          }
        )
    },
    handleFileUpload (file) {
      var url = 'https://www.kundematch.dk/HenttilbudImg.php?img=' + file[0]
      var data = {
        operation: 'badgeDownload',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        url: url
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            this.files = 'data:image/png;base64,' + encodeURI(res.url)
          } else {
            this.$toastr('error', 'Fejl')
          }
        },
        (response) => {
          alert('Error in handleFileUpload()')
        }
      )
      document.querySelector('.education-upload > .input-group > button').classList.add('hide')
    },
    addEducation () {
      var uploadFinish = localStorage.getItem('uploadFinish')
      if (uploadFinish === true || uploadFinish === null) {
        var name = this.name
        var fag = this.fag
        var file = this.files
        if (name !== '' && fag !== null && file !== '') {
          var data = {
            operation: 'addeducation',
            salesPerson: this.salesPerson,
            levid: this.haaId,
            title: name,
            file: file,
            person: name,
            fag: fag
          }
          this.$http.post('', data, { emulateJSON: true })
            .then(
              response => {
                var res = response.body
                if (res.success) {
                  let obj = {
                    title: 'Gennemført!',
                    message: '',
                    type: 'success'
                  }
                  this.displayEducation()
                  this.$refs.simplert.openSimplert(obj)
                  this.name = ''
                  this.fag = null
                  this.files = ''
                  document.querySelector('.education-upload > .input-group > button').classList.remove('hide')
                  var lists = document.querySelectorAll('ul.upload-file-list > li')
                  if (lists.length > 0) {
                    for (var i = 0; i < lists.length; i++) {
                      lists[i].remove()
                    }
                  }
                  this.sendDisabled = false
                } else {
                  this.sendDisabled = false
                  this.$toastr('error', 'Fejl')
                }
              },
              response => {
                alert('Error in addEducation()')
              }
            )
          this.sendDisabled = true
        } else if (fag === '' || fag === null) {
          this.error = true
          if (name === '') {
            this.errormessagename = this.errorFeedback('name')
          } else {
            if (name !== '' && name !== null) {
              this.errormessagename = ''
            }
            this.errormessagefag = this.errorFeedback('education')
            this.$toastr('error', 'Felt kræves')
          }
        } else if (name === '' && name === null) {
          this.$toastr('error', 'Skriv venligst din navn')
          this.error = true
          this.errormessagename = this.errorFeedback('name')
        } else {
          this.$toastr('error', 'Felt kræves')
        }
      } else {
        this.$toastr('error', 'Uploader stadig')
      }
    },
    confirmDelete (id) {
      return dialog => this.deleteEducation(id)
    },
    deleteEducation (id) {
      var data = {
        operation: 'deleducation',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        eduid: id
      }
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.success) {
              this.displayEducation()
              this.$toastr('success', 'Slettet')
            } else {
              this.$toastr('error', 'Fejl')
            }
          },
          response => {
            alert('Error in deleteEducation()')
          }
        )
    },
    errorFeedback (type) {
      var message = {
        default: 'Skriv venligst hvad du ønsker at få lavet',
        email: 'Skriv venligst din email',
        name: 'Skriv venligst din navn',
        phone: 'Skriv venligst dit telefon nummer',
        postal: 'Skriv venligst dit postnummer',
        acceptTerms: 'Venligst klik i vores betingelser',
        education: 'Skriv venligst din fag'
      }
      return message[type]
    },
    disableerror () {
      this.error = false
    }
  }
}
</script>
<style>
  #uddanelsebevis .el-table td, #uddanelsebevis .el-table th.is-leaf {
      border-bottom: 1px solid #EBEEF5;
  }
  #uddanelsebevis button.delete-button {
    display: none;
  }
  @media (max-width: 52em) {
    #ordrestyring label#gemme__BV_label_ {
        display: none !important;
    }
  }
</style>



// WEBPACK FOOTER //
// UddanelseBevis.vue?53424cac